import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useBaseMessageStyles = makeStyles({
  root: {
    position: 'relative',
    '& > div': {
      wordBreak: 'normal',
      overflowWrap: 'anywhere',
    },
    '& p, & ul': {
      marginTop: '0',
      marginBottom: '0',
    },
    '& table': {
      borderCollapse: 'collapse',
      width: '100%',
      marginTop: tokens.spacingVerticalS,
      marginBottom: tokens.spacingVerticalS,
      ...shorthands.border(tokens.strokeWidthThin, 'solid', 'black'),
      '& th, & td': {
        textAlign: 'right',
        ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingHorizontalS),
        ...shorthands.border(tokens.strokeWidthThin, 'solid', 'black'),
      },
      '& th': {
        textAlign: 'center',
        backgroundColor: '#d5d5d5',
        fontWeight: 'bold',
      },
      '& tr:nth-child(even)': {
        backgroundColor: '#d5d5d5',
      },
    },
    '&.human-message': {
      backgroundColor: '#DEECF9',
      boxShadow: 'none',
      float: 'right',
      clear: 'both',
      maxWidth: '88%',
    },
    '&.ai-message': {
      boxShadow: tokens.shadow2,
      float: 'left',
      clear: 'both',
      '& a': {
        wordBreak: 'break-all',
      },
      minWidth: '272px',
    },
  },
  actions: {
    position: 'relative',
  },
});
